var _circle, _path, _path2, _path3, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassPartition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1283_133)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28V72",
    stroke: "#393184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28V72",
    stroke: "#393184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28V72",
    stroke: "#393184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1283_133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 20,
    height: 44,
    fill: "url(#paint1_linear_1283_133)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 20,
    height: 44,
    stroke: "url(#paint2_linear_1283_133)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1283_133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 20,
    height: 44,
    fill: "url(#paint3_linear_1283_133)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 20,
    height: 44,
    stroke: "url(#paint4_linear_1283_133)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1283_133",
    x: 27.85,
    y: 25.85,
    width: 24.3,
    height: 48.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1283_133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1283_133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1283_133",
    x: 47.85,
    y: 25.85,
    width: 24.3,
    height: 48.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1283_133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1283_133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1283_133",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1283_133",
    x1: 32.1402,
    y1: 32.0595,
    x2: 58.0784,
    y2: 38.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1283_133",
    x1: 41.6667,
    y1: 35.3333,
    x2: 64.413,
    y2: 59.4582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1283_133",
    x1: 52.1402,
    y1: 32.0595,
    x2: 78.0784,
    y2: 38.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1283_133",
    x1: 61.6667,
    y1: 35.3333,
    x2: 84.413,
    y2: 59.4582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassPartition);
export default __webpack_public_path__ + "static/media/glass-partition.98c4bc6477d5a9dcb71c97cf2f4d39fa.svg";
export { ForwardRef as ReactComponent };